<div class="card">
	<div class="card-header">
		<h3>Historial de Inventarios Aleatorios</h3>
	</div>
	<div class="card-body">
		<div class="form-group">
			<label for="warehouse" class="form-label">Bodega:</label>
			<div class="input-group">
				<app-input-autocomplete [padding]="false" (changeStatus)="selectWarehouse($event.filterElement)"
					(inputMethod)="searchWarehouse()" [allBorderRadius]="true" [filterElements]="warehouses"
					[placeholder]="'Ingresa una bodega'" [custom]="true" [inputs]="filterWarehouse">
					<ng-template #itemsTemplate let-filter>
						<div items style="border-bottom: 1px solid rgba(255, 255, 255, 0.512);">
							<div class="row">
								<div class="col-sm-2" *ngIf="filter.id!=-1"
									style="display: flex; align-items: center; flex-direction: row; justify-content: center;">
									<h1 style="color: white; text-align: center; margin: 0;">
										{{missingWarehouses[filter.id]?missingWarehouses[filter.id]:0}}</h1>
									<div>
										<span style="color: gray;">DÍAS</span>
										<br style="margin: 0;">
										<span>SIN CONTAR</span>
									</div>
								</div>
								<div class="col-sm-2" *ngIf="filter.id==-1"
									style="display: flex; align-items: center; flex-direction: row; justify-content: center;">
									<h1 style="color: white; text-align: center; margin: 0;"><i class="fa fa-warehouse"></i></h1>
								</div>
								<div class="col-sm-10" *ngIf="filter.id != -1">
									<h5 class="text-info" style="line-height: normal; margin-bottom: 0;">
										{{filter.name}}</h5>
									<span class="text-muted" style="color: white !important;">{{filter.code}} -
										NIT:
										<ng-container *ngIf="filter.nit">
											<b>{{filter.nit}}</b>
										</ng-container>
										<ng-container *ngIf="!filter.nit">
											<span style="color: gray;">
												<i class="fa fa-circle-info"></i>No cuenta con NIT
											</span>
										</ng-container>
									</span>
								</div>
								<div class="col-sm-10" *ngIf="filter.id == -1" style="display: flex; align-items: center;">
									<h2 style="font-weight: bolder; margin: 0;" class="text-info">{{filter.name}}</h2>
								</div>
							</div>
						</div>
					</ng-template>
				</app-input-autocomplete>
			</div>
		</div>
		<div class="info-cards">
			<div class="stats-container">
				<span class="display-5"><i class="fa fa-boxes"></i></span>
				<div class="stat-info">
					<h5>
						<ng-container *ngIf="!loading">
							{{missingProducts}}
						</ng-container>
						<app-loading-animation *ngIf="loading"></app-loading-animation>
					</h5>
					<span>No contados</span>
				</div>
			</div>
			<div class="stats-container" *ngIf="filterWarehouse.data && filterWarehouse.data != -1 && missingWarehouses[filterWarehouse.data.id]">
				<span class="display-5"><i class="fa fa-calendar-days"></i></span>
				<div class="stat-info">
					<h5>
						<ng-container *ngIf="!loading">
							{{missingWarehouses[filterWarehouse.data.id]}}
						</ng-container>
						<app-loading-animation *ngIf="loading"></app-loading-animation>
					</h5>
					<span>Días no contados</span>
				</div>
			</div>
			<div class="stats-container">
				<span class="display-5"><i class="fa fa-calendar"></i></span>
				<div class="stat-info">
					<h5>
						<ng-container *ngIf="!loading">
							{{created | date: 'dd/MM/YYYY'}}
						</ng-container>
						<app-loading-animation *ngIf="loading"></app-loading-animation>
					</h5>
					<span>Fecha creación de Inventario</span>
				</div>
			</div>
			<!-- <div class="stats-container" style="border-left: 4px solid var(--bs-bg-servicios);">
				<span class="display-5"><i class="fa fa-warehouse"></i></span>
				<div class="stat-info">
					<span style="max-width: 50px;">Bodegas y días faltantes</span>
				</div>
			</div>
			<div *ngIf="loading">
				<app-loading-animation style="display: block; width: 6rem;" [height]="'3rem'"></app-loading-animation>
			</div>
			<div class="stats-container" *ngFor="let warehouse of missingWarehouses">
				<span class="display-5" style="font-weight: bolder;">{{warehouse.missingDays}}</span>
				<div class="stat-info">
					<h5>{{warehouse.warehouse.code}}</h5>
					<span style="max-width: 50px;">{{warehouse.warehouse.name}}</span>
				</div>
			</div> -->
		</div>

		<div class="date-filter mb-3" *ngIf="filterWarehouse.data.id != -1">
			<ng-container *ngIf="!filterByDate; else datePicker">
				<input
				type="text"
				value="Todas las fechas"
				readonly
				class="form-control"
				/>
			</ng-container>

			<ng-template #datePicker>
				<input
				type="date"
				class="form-control"
				[(ngModel)]="selectedDate"
				(ngModelChange)="onDateChange($event)"
				/>
			</ng-template>

			<button
				type="button"
				class="btn btn-outline-primary"
				(click)="toggleDateFilter()"
			>
				{{ filterByDate ? 'Mostrar todas las fechas' : 'Filtrar por fecha' }}
			</button>
		</div>

		<div class="table-responsive">
			<table class="table table-bordered">
				<thead>
					<tr class="tr-middle">
						<th rowspan="2" *ngIf="filterWarehouse.data && filterWarehouse.data.id != -1">Contado</th>
						<th colspan="2">Códigos</th>
						<th rowspan="2">Nombre</th>
						<th colspan="2">Unidades</th>
						<th rowspan="2">Diferencia</th>
						<th rowspan="2" *ngIf="filterWarehouse.data && filterWarehouse.data.id != -1">Comentario</th>
					</tr>
					<tr class="tr-middle">
						<th>de Barras</th>
						<th>Producto</th>
						<th>Físicas</th>
						<th>Sistema</th>
					</tr>
				</thead>
				<tbody>
					<tr class="tr-middle" [ngClass]="existence.difference?!existence.surplus?'danger':'warning':''"
						*ngFor="let existence of filteredRecords">
						<td *ngIf="filterWarehouse.data && filterWarehouse.data.id != -1">
							<ng-container *ngIf="existence.user">
								<i class="fa fa-user"></i>{{existence.user.email}}
							</ng-container>
							<br>
							<i class="fa fa-calendar"></i>{{existence.date | date: 'dd/MM/YYYY'}}
						</td>
						<td>
							{{existence.product.barCode}}
							<div class="superposition-parent" *ngIf="!existence.product.barCode">
								<i class="fa fa-barcode"></i>
								<i class="fa fa-question superposition-icon"></i>
							</div>
						</td>
						<td>{{existence.product.code}}</td>
						<td>{{existence.product.name}}</td>
						<td *ngIf="existence.user || (filterWarehouse.data && filterWarehouse.data.id == -1)">
							{{existence.physicalStock}}
						</td>
						<td *ngIf="existence.user || (filterWarehouse.data && filterWarehouse.data.id == -1)">
							{{existence.systemStock}}
						</td>
						<td colspan="2" *ngIf="!existence.user && (filterWarehouse.data && filterWarehouse.data.id != -1)">
							<span class="text-muted">
								<i class="fa fa-circle-info"></i>No se contó
							</span>
						</td>
						<td>
							{{existence.difference}}
							<ng-container *ngIf="existence.difference">
								<i [ngClass]="!existence.surplus?'fa-circle-arrow-up text-danger':'fa-circle-arrow-down text-warning'"
									class="fa"></i>
							</ng-container>
						</td>
						<td *ngIf="filterWarehouse.data && filterWarehouse.data.id != -1">
							{{existence.comment}}
						</td>
					</tr>
					<tr *ngIf="!loading && filteredRecords.length==0 && filterByDate && (filterWarehouse.data && filterWarehouse.data.id != -1)">
						<td style="padding: 2em;" colspan="8">
							<div class="d-flex align-items-center" style="justify-content: center">
								<!-- <i class="fa fa-circle-info"></i> -->
								<strong role="status" style="font-size: 2rem;">En esta Fecha no se Ingreso al Inventario Aleatorio para esta Bodega</strong>
							</div>
						</td>
					</tr>
					<tr *ngIf="loading">
						<td style="padding: 2em;" colspan="6">
							<div class="d-flex align-items-center" style="justify-content: space-around;">
								<strong role="status" style="font-size: 2rem;">Cargando...</strong>
								<app-loading-animation [height]="'5rem'"></app-loading-animation>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>